import { render, staticRenderFns } from "./TemplatePersonaEdit.vue?vue&type=template&id=1b56a55e&scoped=true"
import script from "./TemplatePersonaEdit.vue?vue&type=script&lang=js"
export * from "./TemplatePersonaEdit.vue?vue&type=script&lang=js"
import style0 from "./TemplatePersonaEdit.vue?vue&type=style&index=0&id=1b56a55e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b56a55e",
  null
  
)

export default component.exports